export default __webpack_public_path__ + "static/media/homepage-banner-image_default.998eadf1.png";